import React, { useEffect, useState } from 'react';
import { SERVER_URL } from '../../../config';
import { Button, Modal, Row, Col, Pagination, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { customerService, documentationService, documentationTaskService, photoService, templateService, authService,
	documentationEventService, documentationTaskFilterService, fileService, exportConfigurationService,
	suggestionListService, exportEventService } from '../../../_services'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePowerpoint, faFileExcel, faFileWord, faExclamationTriangle, faFileExport, faCamera, faPaintbrush,
	faFont, faHashtag, faListCheck, faChevronUp, faChevronDown, faPaperclip, faFilePdf, faGear,
	faHeading, faEdit, faUsers, faBarcode, faAngleLeft, faAnglesLeft, faAngleRight, faAnglesRight, faEyeSlash }
		from '@fortawesome/free-solid-svg-icons'
import { faSquareCheck, faSquare, faFolder, faCalendar, faClock, faMap } from '@fortawesome/free-regular-svg-icons'
import ExportButton from './exportbutton';
import EditPhotoButton from './editphotobutton';
import EditFileButton from './editfilebutton';
import EditTaskButton from './edittaskbutton';
import DeletePhotoButton from './deletephotobutton';
import DeleteFileButton from './deletefilebutton';
import ToggleHiddenButton from './togglehiddenbutton';
import RenameButton from './renamebutton';
import HandledButton from './handledbutton';
import ApprovedButton from './approvedbutton';
import PausedButton from './pausedbutton';
import PhotoImportButton from './photoimportbutton';
import FileImportButton from './fileimportbutton';
import TaskEventButton from './taskeventbutton';
import ExportDocumentButton from './exportdocumentbutton';
import CompleteButton from './completebutton';
import { getProductName } from '../../../_helpers';
import DocumentationTaskFilter from './documentationtaskfilter';
import './details.css'
import ImageZoom from "react-image-zooom";
import { GoogleMap, Marker, Polygon } from '@react-google-maps/api'

function DocumentationDetails() {

	const [documentation, setDocumentation] = useState(null)
	const [hasFormProduct, setHasFormProduct] = useState(false)
	const [documentationTasks, setDocumentationTasks] = useState([])
	const [documentationEvents, setDocumentationEvents] = useState([])
	const [template, setTemplate] = useState(null)
	const [exportEvents, setExportEvents] = useState([])
	const [photos, setPhotos] = useState([])
	const [photoIndex, setPhotoIndex] = useState(0)
	const [files, setFiles] = useState([])
	const [exportConfigurations, setExportConfigurations] = useState([])
	const [suggestionLists, setSuggestionLists] = useState([])

	const [showPhotoModal, setShowPhotoModal] = useState(false)
	const [showExportPhotoEventModal, setShowExportPhotoEventModal] = useState(false)
	const [showExportFileEventModal, setShowExportFileEventModal] = useState(false)
	const [backdrop, setBackdrop] = useState(false)

	const [filters, setFilters] = useState([])
	const [showUnanswered, setShowUnanswered] = useState(false)
	const [sort, setSort] = useState('name')
	const [order, setOrder] = useState('asc')
	const {uuid} = useParams()
    const {t} = useTranslation('common')
    const dateFormat = 'yyyy-MM-DD HH:mm:ss'
    const userId = authService.getCurrentUser().id

    const editableTaskTypes = ['TEXT', 'CHECKBOX', 'SINGLE_CHOICE', 'MULTI_CHOICE', 'INTEGER', 'DECIMAL',
        'SINGLE_CHOICE_SUGGESTION', 'MULTI_CHOICE_SUGGESTION', 'DATE', 'DATE_RANGE', 'TIME', 'DATE_TIME',
        'ZEBRA_SCANNER', 'PREDEFINED', 'CONTACT_PERSONS', 'MAP_MARKER', 'MAP_MULTIPLE_MARKERS', 'MAP_POLYGON']

    useEffect(() => {
		if (!authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
			setHasFormProduct(authService.hasProducts(['FORM']))
		}

		documentationService.get(uuid).then(documentation => {
			documentation.exportEvents.sort((event1, event2) => event1.dateCreated.localeCompare(event2.dateCreated))
			setExportEvents(documentation.exportEvents)
            setDocumentation(documentation)

            templateService.get(documentation.templateId).then(data => {
	            setTemplate(data)
	            //setSelectedExportConfigurations(data.exportConfigurations.map(exportConfiguration => exportConfiguration.id))
	        })

	        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
				customerService.show(documentation.customerId).then(data => {
					setHasFormProduct(data.products.some(product => product.name === "FORM"))
				})
			}

			documentationTaskFilterService.list().then(data => {
				if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
					data = data.filter(filter => filter.customerId == documentation.customerId)
				}
	            data.forEach(filter => {
	                filter.active = filter.automatic
	            })
	            setFilters(data)
	        })

	        if (documentation.status == 'PAUSED' || documentation.status == 'DRAFT') {
	            setShowUnanswered(true)
	        }
        })
        documentationTaskService.findAllByDocumentation(uuid).then(data => {
            data.sort((task1, task2) => task1.position - task2.position)
            data.forEach(task => {
                if (task.type == "GROUP") {
                    task.expanded = true
                }
            })
            setDocumentationTasks(data)
        })
        photoService.getAllDocumentationPhotos(uuid).then(data => {
            data.sort((photo1, photo2) => photo1.name.localeCompare(photo2.name))
            setPhotos(data)
            //setSelectedPhotos(data.map(photo => photo.id))
        })
        if (authService.hasRoles(['ROLE_FILE_READ'])) {
	        fileService.getAllDocumentationFiles(uuid).then(data => {
	            data.sort((file1, file2) => file1.name.localeCompare(file2.name))
	            setFiles(data)
	        })
        }
        documentationEventService.list(uuid, 100).then(data => {
            data.sort((event1, event2) => event1.eventDate.localeCompare(event2.eventDate))
            setDocumentationEvents(data)
        })
        if (authService.hasRoles(['ROLE_EXPORT_CONFIGURATION_READ'])) {
	        exportConfigurationService.list().then(data => {
	            data.sort((a, b) => a.name.localeCompare(b.name))
	            setExportConfigurations(data)
	        })
        }
        if (authService.hasRoles(['ROLE_SUGGESTION_LIST_READ'])) {
	        suggestionListService.list().then(data => {
	            setSuggestionLists(data)
	        })
        }
    }, [])

    useEffect(() => {
		const handleKeyDown = (e) => {
			console.log('handleKeyDown')

			if (showPhotoModal) {
                const key = e.key
	            switch (key) {
	                case "ArrowLeft":
	                    var newPhotoIndex = Math.max(0, photoIndex - 1)
	                    setPhotoIndex(newPhotoIndex)
	                    break
	                case "ArrowRight":
	                    var newPhotoIndex = Math.min(photos.length - 1, photoIndex + 1)
	                    setPhotoIndex(newPhotoIndex)
	                    break
	            }
            }
        }
        document.addEventListener('keydown', handleKeyDown, false)

        return () => {
	        document.removeEventListener('keydown', handleKeyDown)
	    }
    }, [photos, photoIndex, showPhotoModal])

    const onClick = photo => {
        console.log('onClick')
        setPhotoIndex(sortPhotos().indexOf(photo))
        setShowPhotoModal(true)
    }

    const onHide = () => {
		setShowPhotoModal(false)
		setBackdrop(false)
		//document.body.className = ""
		//document.body.style = '';
    }

    const onHideExportPhotoEventModal = () => {
		setShowExportPhotoEventModal(false)
		setBackdrop(false)
    }

    const onHideExportFileEventModal = () => {
		setShowExportFileEventModal(false)
		setBackdrop(false)
    }

    const sortPhotos = () => {
        console.log('sortPhotos')
        if (documentationTasks.length == 0) {
            if (sort == 'name') {
	            photos.sort((a, b) => a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase() ? -1 : 1)
	        } else {
	            photos.sort((a, b) => a.dateCreated.toLocaleUpperCase() < b.dateCreated.toLocaleUpperCase() ? -1 : 1)
	        }
	        if (order == 'desc') {
	            photos.reverse()
	        }

	        return photos
        }
        var result = []
        documentationTasks.forEach(task => {
            var filteredPhotos = photos.filter(photo => photo.documentationTaskId === task.id)
            filteredPhotos.sort((a, b) => a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase() ? -1 : 1)
            result = result.concat(filteredPhotos)
        })
        return result
    }

    const renderItem = (item, options) => {
        if (options && options.isSelected) {
			return item
        }
        return <></>
    }

    const toggleGroup = (group) => {
        console.log('toggleGroup')
        group.expanded = !group.expanded
        let newTasks = [...documentationTasks]
        setDocumentationTasks(newTasks)
    }

    const importPhotoCallback = (newPhoto) => {
        newPhoto.exportEvents = []
		var newPhotos = [...photos, newPhoto]
		newPhotos.sort((photo1, photo2) => photo1.name.localeCompare(photo2.name))
		setPhotos(newPhotos)
    }

    const onExport = (result) => {

    }

    const onUpdatePhoto = (result) => {
		let newPhotos = photos.map(photo => {
			if (photo.id === result.id) {
				return result
			}
			return photo
		})
		setPhotos(newPhotos)
    }

    const onUpdateFile = (result) => {
		let newFiles = files.map(file => {
			if (file.id === result.id) {
				return result
			}
			return file
		})
		setFiles(newFiles)
    }

    const onUpdateTask = (result) => {
		let newTasks = documentationTasks.map(task => {
			if (task.id === result.id) {
				return result
			}
			return task
		})
		setDocumentationTasks(newTasks)
    }

    const onDeletePhoto = (deletedPhotoId) => {
		let newPhotos = photos.filter(photo => photo.id != deletedPhotoId)
		setPhotos(newPhotos)
//		let newSelectedPhotos = selectedPhotos.filter(photoId => photoId != deletedPhotoId)
//		setSelectedPhotos(newSelectedPhotos)
    }

    const onDeleteFile = (deletedFileId) => {
		let newFiles = files.filter(file => file.id != deletedFileId)
		setFiles(newFiles)
//		let newSelectedFiles = selectedFiles.filter(fileId => fileId != deletedFileId)
//		setSelectedFiles(newSelectedFiles)
    }

    const onFileImport = (file) => {
		console.log(file)

		let newFiles = [...files, file]
		setFiles(newFiles)

		if (documentation.status == 'WAITING_FOR_FILE') {
			let stillWaiting = documentationTasks.some(task => {
				return task.type == 'FILE' && task.required == 'NO_WITH_LATER_UPLOAD' && !newFiles.some(file => file.documentationTaskId == task.id)
			})

			if (!stillWaiting) {
				window.location.reload()
			}
		}
    }

    const getPaginationItems = () => {
        var items = []

		if (photos.length < 10) {
			items = photos.map((photo, index) => {
				return <Pagination.Item
					key={photo.id}
					active={photoIndex == index}
					onClick={e => setPhotoIndex(index)}
				>
		            {index+1}
		        </Pagination.Item>
			})
		} else {
			var indexSet = new Set()
			indexSet.add(0)
			indexSet.add(1)
			indexSet.add(2)
			indexSet.add(photos.length - 3)
			indexSet.add(photos.length - 2)
			indexSet.add(photos.length - 1)

			if (photoIndex > 0) {
				indexSet.add(photoIndex-1)
			}
			indexSet.add(photoIndex)
			if (photoIndex < photos.length - 1) {
				indexSet.add(photoIndex+1)
			}

			var indexes = Array.from(indexSet)
			indexes.sort((a, b) => a - b)

			var lastIndex = 0

			for (const index of indexes) {
				if (index - lastIndex > 1) {
					items.push(<Pagination.Ellipsis key={'ellipsis-' + index} disabled/>)
				}
				var photo = photos[index]
			    items.push(<Pagination.Item
					key={photo.id}
					active={photoIndex == index}
					onClick={e => setPhotoIndex(index)}
				>
		            {index+1}
		        </Pagination.Item>)

		        lastIndex = index
			}
		}

        return items
    }

    const getDocumentationTaskView = (documentationTask) => {
		switch (documentationTask.type) {
			case 'PHOTO':
			case 'DRAWING':
				var taskPhotos = photos.filter(photo => photo.documentationTaskId === documentationTask.id)
				if (taskPhotos.length == 0 && documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutphotoserror')}
					</div>
				}
				return <Row>
					{ taskPhotos.map(photo => {
	                    return <Col lg="2" md="3" sm="4" xs="6" key={photo.id}>
	                        <div className="clearfix" style={{paddingTop: '20px'}}>
								<div className="float-left">
	                                {photo.alias || photo.name}
	                            </div>
	                            { authService.hasRoles(['ROLE_PHOTO_WRITE']) &&
		                            <div className="float-right" style={{"marginBottom": "1px"}}>
		                                <EditPhotoButton
											data={photo}
											onUpdate={onUpdatePhoto}
										/>
										<DeletePhotoButton
											data={photo}
											onDelete={onDeletePhoto}
										/>
		                            </div>
	                            }
	                        </div>
							<a onClick={() => onClick(photo)} key={photo.id} style={{cursor: 'pointer'}}>
		                        <img src={SERVER_URL + '/photo/thumbnail/' + photo.id + '?t=' + photo.lastUpdated} style={{width: '100%'}}/>
		                    </a>
		                    <br/>
		                    {photo.comment ? '(' + photo.comment + ')' : ''}
	                    </Col>
	                })}
				</Row>
				break;
			case 'FILE':
				var taskFiles = files.filter(file => file.documentationTaskId === documentationTask.id)
				if (taskFiles.length == 0 && documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutfileserror')}
					</div>
				}
				return <>
					{ taskFiles.length == 0 && documentationTask.required == 'NO_WITH_LATER_UPLOAD' &&
						<div>
							<FontAwesomeIcon icon={faExclamationTriangle} style={{color: '#FF0000'}}/>
							&nbsp;
							{t('documentation.nofileserror')}
						</div>
					}
					{ taskFiles.map(file => {
	                    return <div key={file.id}>
		                    <a href={SERVER_URL + '/file/download/' + file.id} target="_blank">
		                        {file.name} ({formatDataSize(file.dataSize)})
		                    </a>
		                    &nbsp;
		                    { authService.hasRoles(['ROLE_FILE_WRITE']) &&
	                            <>
	                                <EditFileButton
										data={file}
										onUpdate={onUpdateFile}
									/>
									<DeleteFileButton
										data={file}
										onDelete={onDeleteFile}
									/>
	                            </>
                            }
	                    </div>
	                })}
				</>
			case 'TEXT':
			case 'INTEGER':
			case 'DECIMAL':
			case 'DATE':
			case 'TIME':
			case 'DATE_TIME':
			case 'ZEBRA_SCANNER':
				if (documentationTask.answer) {
					return <div>{documentationTask.answer}</div>
				} else if (documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutanswererror')}
					</div>
				}
				return <div>-</div>
			case 'CHECKBOX':
				return <div>
					<FontAwesomeIcon icon={documentationTask.answer ? faSquareCheck : faSquare}/>
					&nbsp;
					{documentationTask.options}
					 { !documentationTask.answer && documentationTask.required == "YES" &&
						<div>
							<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
							&nbsp;
							{t('documentation.taskwithoutanswererror')}
						</div>
					}
				</div>
			case 'SINGLE_CHOICE':
			case 'MULTI_CHOICE':
				if (documentationTask.answer) {
					var options = documentationTask.options.split(";")
					var answers = documentationTask.answer.split(";")
					return <div>
						{ options.map(option => {
							return <div key={documentationTask.id + '-' + option}>
								<FontAwesomeIcon icon={answers.includes(option) ? faSquareCheck : faSquare}/>
								&nbsp;
								{option}
							</div>
						})}
						{ documentationTask.unexpectedAnswerEvents.map(event => {
							return <div key={event.id} className="alert alert-danger" role="alert">
								{t('documentation.expectedanswer', {list: event.expectedAnswerListName, answer: event.expectedAnswer})}
							</div>
						})}
					</div>
				} else if (documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutanswererror')}
					</div>
				}
				return <div>-</div>
			case 'SINGLE_CHOICE_SUGGESTION':
			case 'MULTI_CHOICE_SUGGESTION':
				if (documentationTask.answer) {
					var answers = documentationTask.answer.split(";").sort()
					return <div>
						{ answers.join(', ') }
						{ documentationTask.unexpectedAnswerEvents.map(event => {
							return <div key={event.id} className="alert alert-danger" role="alert">
								{t('documentation.expectedanswer', {list: event.expectedAnswerListName, answer: event.expectedAnswer})}
							</div>
						})}
					</div>
				} else if (documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutanswererror')}
					</div>
				}
				return <div>-</div>
			case 'GROUP':
				if (documentationTask.expanded) {
					var children = documentationTasks.filter(task => task.parent == documentationTask.id)
					return <div>
						{ children.map(child => {
							child.enabled = checkPreconditions(child) && documentationTask.enabled
							let show = showTask(child) && checkFilters(child)
							if (child.enabled && show) {
								let textColor = child.enabled ? 'auto' : '#BBBBBB'
								return <div key={child.id} style={{marginBottom: '2px', padding: '10px 10px', border: '1px solid #ccc'}}>
									<h5 style={{color: textColor}}>
										<div style={{width: '1em', display: 'inline-block', textAlign: 'center'}}>
											{getDocumentationTaskIcon(child)}
										</div>
										&nbsp;
										{child.name}
										&nbsp;
										{ isEditable(child) &&
											<>
												&nbsp;
												<EditTaskButton
													data={child}
													documentation={documentation}
													onUpdate={onUpdateTask}
												/>
											</>
										}
										<TaskEventButton task={child}/>
										{ child.type == "GROUP" &&
											<a onClick={(e) => toggleGroup(child)} style={{cursor: 'pointer', paddingLeft: '10px'}}>
												<FontAwesomeIcon icon={child.expanded ? faChevronUp : faChevronDown}/>
											</a>
										}
									</h5>
									{ child.description &&
										<i style={{color: textColor}}>{child.description}</i>
									}
									{ (child.enabled || child.type == 'GROUP') &&
										getDocumentationTaskView(child)
									}
								</div>
							}
							return <div key={child.id}></div>
						})}
					</div>
				} else {
					return <></>
				}
			case 'HEADER':
				return <></>
			case 'PREDEFINED':
				if (documentationTask.answer) {
					return <div>{documentationTask.answer}</div>
				} else if (documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutanswererror')}
					</div>
				}
				return <div>-</div>
			case 'DATE_RANGE':
				if (documentationTask.answer && documentationTask.answer.includes(";")) {
					var split = documentationTask.answer.split(";")
					return <div>{split[0]} - {split[1]}</div>
				} else if (documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutanswererror')}
					</div>
				}
				return <div>-</div>
			case 'CONTACT_PERSONS':
				if (documentationTask.answer && documentationTask.answer.includes(";")) {
					var rows = documentationTask.answer.split("\n")
					var suggestionList = suggestionLists.find(suggestionList => suggestionList.id == documentationTask.options)
					return <table>
						{ suggestionList && suggestionList.params.columns &&
							<thead>
								<tr>
									{ suggestionList.params.columns.split(";").map(column => {
										return <th key={documentationTask.id + "-" + column} style={{paddingRight: 10}}>
											{column}
										</th>
									})}
								</tr>
							</thead>
						}
						<tbody>
							{ rows.map((row, index) => {
								return <tr key={documentationTask.id + "-" + index}>
									{ row.split(";").map((value, valueIndex) => {
										return <td key={documentationTask.id + "-" + index + "-" + valueIndex} style={{paddingRight: 10}}>
											{value}
										</td>
									})}
								</tr>
							})}
						</tbody>
					</table>
				} else if (documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutanswererror')}
					</div>
				}
				return <div>{documentationTask.answer}</div>
			case 'MAP_MARKER':
			case 'MAP_MULTIPLE_MARKERS':
			case 'MAP_POLYGON':
				if (documentationTask.answer) {
					var latLngs = []
					if (documentationTask.type == 'MAP_MARKER') {
						var latLng = documentationTask.answer.split(';').map(value => parseFloat(value))
						latLngs.push(latLng)
					} else if (documentationTask.type == 'MAP_MULTIPLE_MARKERS' || documentationTask.type == 'MAP_POLYGON') {
						var rows = documentationTask.answer.split("\n")
						rows.forEach(row => {
							var latLng = row.split(';').map(value => parseFloat(value))
							latLngs.push(latLng)
						})
					}
					return <GoogleMap
						onLoad={map => onMapLoad(map, latLngs)}
						mapContainerStyle={{ width: '500px', height: '500px' }}
				        options={{ minZoom: 3, zoomControl: true }}>
				        { documentationTask.type == 'MAP_MARKER' &&
				            <Marker
			                    position={{ lat: latLngs[0][0], lng: latLngs[0][1] }}
			                />
				        }
				        { documentationTask.type == 'MAP_MULTIPLE_MARKERS' &&
				            <>
				                { latLngs.map(latLng => {
				                    return <Marker
				                        key={latLng[0] + "-" + latLng[1]}
					                    position={{ lat: latLng[0], lng: latLng[1] }}
					                />
				                })}
				            </>
				        }
			            { documentationTask.type == 'MAP_POLYGON' &&
			                <>
				                { latLngs.map(latLng => {
				                    return <Marker
				                        key={latLng[0] + "-" + latLng[1]}
					                    position={{ lat: latLng[0], lng: latLng[1] }}
					                />
				                })}
				                <Polygon paths={latLngs.map(latLng => { return { lat: latLng[0], lng: latLng[1] }})}/>
				            </>
				        }
					</GoogleMap>
				} else if (documentationTask.required == "YES") {
					return <div>
						<FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
						&nbsp;
						{t('documentation.taskwithoutanswererror')}
					</div>
				}
				return <>-</>
		}
    }

    const getDocumentationTaskIcon = (documentationTask) => {
	    switch (documentationTask.type) {
			case 'PHOTO':
				return <FontAwesomeIcon icon={faCamera}/>
			case 'FILE':
				return <FontAwesomeIcon icon={faPaperclip}/>
			case 'DRAWING':
				return <FontAwesomeIcon icon={faPaintbrush}/>
			case 'TEXT':
			case 'STATIC_TEXT':
				return <FontAwesomeIcon icon={faFont}/>
			case 'HEADER':
				return <FontAwesomeIcon icon={faHeading}/>
			case 'INTEGER':
			case 'DECIMAL':
				return <FontAwesomeIcon icon={faHashtag}/>
			case 'CHECKBOX':
				return <FontAwesomeIcon icon={faListCheck}/>
			case 'SINGLE_CHOICE':
			case 'MULTI_CHOICE':
			case 'SINGLE_CHOICE_SUGGESTION':
			case 'MULTI_CHOICE_SUGGESTION':
				return <FontAwesomeIcon icon={faListCheck}/>
			case 'GROUP':
				return <FontAwesomeIcon icon={faFolder}/>
			case 'PREDEFINED':
				return <FontAwesomeIcon icon={faGear}/>
			case 'DATE':
			case 'DATE_RANGE':
			case 'DATE_TIME':
				return <FontAwesomeIcon icon={faCalendar}/>
			case 'TIME':
				return <FontAwesomeIcon icon={faClock}/>
			case 'CONTACT_PERSONS':
				return <FontAwesomeIcon icon={faUsers}/>
			case 'ZEBRA_SCANNER':
				return <FontAwesomeIcon icon={faBarcode}/>
			case 'MAP_MARKER':
			case 'MAP_MULTIPLE_MARKERS':
			case 'MAP_POLYGON':
				return <FontAwesomeIcon icon={faMap}/>
		}
		return <FontAwesomeIcon icon={faCamera}/>
    }

    const getDocumentationEventType = (event) => {
        switch (event.type) {
            case "CREATED":
                return t('documentationevent.types.created')
            case "UPLOADED":
                return t('documentationevent.types.uploaded')
            case "PAUSED":
                return t('documentationevent.types.paused')
            case "DOWNLOADED":
                return t('documentationevent.types.downloaded')
            case "COMPLETED":
                return t('documentationevent.types.completed')
            case "MERGED":
                return t('documentationevent.types.merged')
            case "STATUS_CHANGED":
                if (event.params && event.params.status) {
                    var status = formatStatus(event.params.status)
                    return t('documentationevent.types.statuschangedto', {status: status})
                }
                return t('documentationevent.types.statuschanged')
            case "RENAMED":
                return t('documentationevent.types.renamed')
            case "TASK_EDIT":
                return t('documentationevent.types.taskedit')
            case "HIDDEN":
                return t('documentationevent.types.hidden')
            case "VISIBLE":
                return t('documentationevent.types.visible')
            case "WAITING_FOR_FILE":
                return t('documentationevent.types.waitingforfile')
            case "DRAFT":
                return t('documentationevent.types.draft')
        }
        return "-"
    }

    const showTask = (documentationTask) => {
        if (documentationTask.type == 'GROUP') {
            var preconditionsOK = checkPreconditions(documentationTask)
			var filtersOK = checkFilters(documentationTask)
			var childrenOK = documentationTasks.filter(task => task.parent == documentationTask.id).some(child => {
				return showTask(child)
			})
			return preconditionsOK && filtersOK && childrenOK
        }

        var answerOK = true
        if (!showUnanswered) {
            answerOK = checkAnswer(documentationTask)
        }
		var preconditionsOK = checkPreconditions(documentationTask)
		var filtersOK = checkFilters(documentationTask)
		return answerOK && preconditionsOK && filtersOK
    }

    const checkAnswer = (documentationTask) => {
        if (documentationTask.required == "YES") {
            return true
        }
        switch (documentationTask.type) {
			case 'PHOTO':
			case 'DRAWING':
				return photos.some(photo => photo.documentationTaskId === documentationTask.id)
			case 'FILE':
				return files.some(file => file.documentationTaskId === documentationTask.id)
			case 'TEXT':
			case 'INTEGER':
			case 'DECIMAL':
			case 'CHECKBOX':
			case 'SINGLE_CHOICE':
			case 'MULTI_CHOICE':
			case 'SINGLE_CHOICE_SUGGESTION':
			case 'MULTI_CHOICE_SUGGESTION':
			case 'DATE':
			case 'DATE_RANGE':
			case 'TIME':
			case 'DATE_TIME':
			case 'PREDEFINED':
			case 'CONTACT_PERSONS':
			case 'ZEBRA_SCANNER':
			case 'MAP_MARKER':
			case 'MAP_MULTIPLE_MARKERS':
			case 'MAP_POLYGON':
				return documentationTask.answer && documentationTask.answer != ''
		}
		return true
    }

    const checkPreconditions = (documentationTask) => {
        return documentationTask.preconditions.every(precondition => {
            switch (precondition.type) {
                case 'TASK_ANSWER': {
                    let taskId = precondition.params['TASK_ID']
                    let operator = precondition.params['OPERATOR']
                    let answer = precondition.params['ANSWER']
					let otherTask = documentationTasks.find(task => task.id == taskId)
					if (otherTask) {
						if (operator == 'EQUALS') {
							return otherTask.answer == answer
						} else if (operator == 'NOT_EQUALS') {
							return otherTask.answer != answer
						}
					}
                    return false
                }
                case 'TASK_PHOTOS_TAKEN': {
                    let taskId = precondition.params['TASK_ID']
                    let otherTask = documentationTasks.find(task => task.id == taskId)
					if (otherTask) {
						var taskPhotos = photos.filter(photo => photo.documentationTaskId === otherTask.id)
						return taskPhotos.length != 0
					}
                    return false
                }
                case 'TASK_NO_PHOTOS_TAKEN': {
                    let taskId = precondition.params['TASK_ID']
                    let otherTask = documentationTasks.find(task => task.id == taskId)
					if (otherTask) {
						var taskPhotos = photos.filter(photo => photo.documentationTaskId === otherTask.id)
						return taskPhotos.length == 0
					}
                    return false
                }
                case 'PLATFORM': {
                    let operator = precondition.params['OPERATOR']
                    let platform = precondition.params['PLATFORM']
					if (operator == 'EQUALS') {
						return platform == "WEB"
					} else if (operator == 'NOT_EQUALS') {
						return platform != "WEB"
					}
                    return false
                }
                case 'TASK_FINISHED':
                    var taskId = precondition.params['TASK_ID']
                    var task = documentationTasks.find(task => task.id == taskId)
                    if (task) {
                        if (task.type == 'PHOTO' || task.type == 'DRAWING') {
                            if (photos.some(photo => photo.documentationTask == taskId)) {
								return true
							}
                        } else if (task.type == 'FILE') {
                            if (files.some(file => file.documentationTask == taskId)) {
								return true
							}
                        } else if (task.answer) {
                            return true
                        }
                    }
                    return false
                case 'TASK_UNFINISHED':
                    var taskId = precondition.params['TASK_ID']
                    var task = documentationTasks.find(task => task.id == taskId)
                    if (task) {
                        if (task.type == 'PHOTO' || task.type == 'DRAWING') {
                            if (!photos.some(photo => photo.documentationTask == taskId)) {
								return true
							}
                        } else if (task.type == 'FILE') {
                            if (!files.some(file => file.documentationTask == taskId)) {
								return true
							}
                        } else if (!task.answer) {
                            return true
                        }
                    }
                    return false
            }
            return false
        })
    }

    const checkFilters = (documentationTask) => {
        if (filters.some(filter => filter.active)) {
            if (documentationTask.type == 'GROUP') {
                let children = documentationTasks.filter(task => task.parent == documentationTask.id)
                return children.some(child => checkFilters(child))
            } else {
	            return filters.filter(filter => filter.active).some(filter => {
	                if (filter.type == 'ANSWER') {
	                    return documentationTask.answer == filter.params.ANSWER
	                } else if (filter.type == 'ANSWER_NOT') {
						return documentationTask.answer != filter.params.ANSWER
	                } else if (filter.type == 'PRECONDITION') {
	                    if (filter.params.PRECONDITION_TYPE == 'TASK_ANSWER') {
	                        return documentationTask.preconditions.some(precondition => {
	                            let sameType = precondition.type == filter.params.PRECONDITION_TYPE
	                            let sameOperator = precondition.params.OPERATOR == filter.params.OPERATOR
	                            let sameAnswer = precondition.params.ANSWER == filter.params.ANSWER
		                        return sameType && sameOperator && sameAnswer
		                    })
	                    } else {
	                        return documentationTask.preconditions.some(precondition => {
	                            return precondition.type == filter.params.PRECONDITION_TYPE
		                    })
	                    }
	                } else if (filter.type == 'TYPE') {
						return documentationTask.answer != filter.params.ANSWER
	                } else if (filter.type == 'ANSWERED') {
	                    var somePhotos = photos.some(photo => photo.documentationTaskId == documentationTask.id)
	                    var someFiles = files.some(file => file.documentationTaskId == documentationTask.id)
						return documentationTask.answer || somePhotos || someFiles
	                } else if (filter.type == 'UNANSWERED') {
	                    var somePhotos = photos.some(photo => photo.documentationTaskId == documentationTask.id)
	                    var someFiles = files.some(file => file.documentationTaskId == documentationTask.id)
						return !documentationTask.answer && !somePhotos && !someFiles
	                }
	                return false
	            })
            }
        }
        return true
    }

    const openAllGroups = () => {
		documentationTasks.forEach(task => {
			if (task.type == 'GROUP') {
				task.expanded = true
			}
		})
		let newTasks = [...documentationTasks]
        setDocumentationTasks(newTasks)
    }

    const closeAllGroups = () => {
		documentationTasks.forEach(task => {
			if (task.type == 'GROUP') {
				task.expanded = false
			}
		})
		let newTasks = [...documentationTasks]
        setDocumentationTasks(newTasks)
    }

    const downloadZipFile = () => {
		let userId = authService.getCurrentUser().id
		window.location.href = SERVER_URL + '/documentation/downloadZipFile/' + uuid + "?userId=" + userId
    }

    const downloadExportDocumentByType = (type) => {
		let userId = authService.getCurrentUser().id
		window.location.href = SERVER_URL + '/documentation/downloadExportDocument/' + uuid + '?type=' + type + '&userId=' + userId
    }

    const onToggleHidden = (hidden) => {
        var newDocumentation = {...documentation, hidden: hidden}
        setDocumentation(newDocumentation)
    }

    const onRenamed = (newName) => {
        var newDocumentation = {...documentation, name: newName}
        setDocumentation(newDocumentation)
    }

    const onStatusChanged = (newStatus) => {
        var newDocumentation = {...documentation, status: newStatus}
        setDocumentation(newDocumentation)

        documentationEventService.list(uuid, 100).then(data => {
            data.sort((event1, event2) => event1.eventDate.localeCompare(event2.eventDate))
            setDocumentationEvents(data)
        })
    }

    const formatDataSize = function(dataSize) {
		var i = Math.floor( Math.log(dataSize) / Math.log(1000) )
        return ( dataSize / Math.pow(1000, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    }

    const formatStatus = status => {
        switch (status) {
            case 'ONGOING':
                return t('documentation.status.ongoing')
            case 'PAUSED':
                return t('documentation.status.paused')
            case 'DOWNLOADED':
                return t('documentation.status.downloaded')
            case 'COMPLETED':
                return t('documentation.status.completed')
            case 'HANDLED':
                return t('documentation.status.handled')
            case 'APPROVED':
                return t('documentation.status.approved')
            case 'WAITING_FOR_FILE':
                return t('documentation.status.waitingforfile')
            case 'DRAFT':
                return t('documentation.status.draft')
        }
    }

    const isEditable = task => {
		if (task.type == 'PREDEFINED') {
			return task.params.editable
		}
        return editableTaskTypes.includes(task.type)
    }

    const onMapLoad = (map, latLngs) => {
        if (latLngs.length == 1) {
            map.setZoom(6)
	        map.setCenter({ lat: latLngs[0][0], lng: latLngs[0][1] })
        } else {
            const bounds = new window.google.maps.LatLngBounds()
			latLngs.forEach(latLng => {
				bounds.extend({lat: latLng[0], lng: latLng[1]})
			})
	        map.fitBounds(bounds)
        }
    }

    const hideExportEvent = (e, exportEvent) => {
        console.log('hideExportEvent')

        e.preventDefault()

        exportEventService.hide(exportEvent.id).then(data => {
            console.log(data)

            exportEvent.hidden = true

            var newExportEvents = [...exportEvents]
            setExportEvents(newExportEvents)
        })
    }

	return (
		<div id="documentation-details">
			{ documentation &&
				<>
					<div className="clearfix">
						<div className="float-left">
							<h2>
				                {documentation.alias ? documentation.alias : documentation.name}
				            </h2>
			            </div>
			            <div className="float-right">
			                { !documentation.dateDeleted &&
			                    <>
			                        { authService.hasRoles(['ROLE_DOCUMENTATION_WRITE']) &&
										<ToggleHiddenButton documentation={documentation} onToggleHidden={onToggleHidden}/>
									}
									{ authService.hasRoles(['ROLE_DOCUMENTATION_WRITE']) &&
										<RenameButton documentation={documentation} onRenamed={onRenamed}/>
									}
									{ authService.hasRoles(['ROLE_DOCUMENTATION_WRITE']) &&
										<>
											{ documentation.status == 'COMPLETED' &&
												<>
													{ (authService.hasDocumentationStatuses(['HANDLED']) || authService.hasRoles(['ROLE_SUPER_ADMIN'])) &&
														<HandledButton documentation={documentation} onStatusChanged={onStatusChanged}/>
													}
													{ (authService.hasDocumentationStatuses(['APPROVED']) || authService.hasRoles(['ROLE_SUPER_ADMIN'])) &&
														<ApprovedButton documentation={documentation} onStatusChanged={onStatusChanged}/>
													}
												</>
											}
											{ ['COMPLETED', 'HANDLED', 'APPROVED', 'DRAFT'].includes(documentation.status) &&
												<>
													{ (authService.hasDocumentationStatuses(['PAUSED']) || authService.hasRoles(['ROLE_SUPER_ADMIN'])) &&
														<PausedButton documentation={documentation} onStatusChanged={onStatusChanged}/>
													}
												</>
											}
											{ documentation.status == 'PAUSED' && authService.hasRoles(['ROLE_SUPER_ADMIN']) &&
												<CompleteButton documentation={documentation} photos={photos} onStatusChanged={onStatusChanged}/>
											}
										</>
									}
			                        { authService.hasRoles(['ROLE_IMPORT_PHOTO']) && documentationTasks.some(task => task.type == 'PHOTO') &&
										<PhotoImportButton
											documentation={documentation}
											documentationTasks={documentationTasks}
											photos={photos}
											callback={importPhotoCallback}
										/>
									}
									{ authService.hasRoles(['ROLE_IMPORT_FILE']) && documentationTasks.some(task => task.type == 'FILE') &&
										<FileImportButton
											documentation={documentation}
											documentationTasks={documentationTasks}
											callback={onFileImport}
										/>
									}
									{ template && template.templateExportConfigurations.length > 0 && exportConfigurations.length > 0 && authService.hasRoles(['ROLE_EXPORT_DOCUMENTATION']) && (!authService.hasProducts(['DOCUMENTATION_COMPARISON']) || authService.hasRoles(['ROLE_SUPER_ADMIN'])) &&
										<ExportButton
											documentation={documentation}
											template={template}
											photos={sortPhotos()}
											files={files}
											tasks={documentationTasks}
											onUpdateExportEvents={result => setExportEvents(result)}
											exportConfigurations={exportConfigurations}
										/>
									}
									{ photos && photos.length > 0 &&
										<Button variant="outline-dark" onClick={e => downloadZipFile()}>
											<FontAwesomeIcon icon={faFileExport} style={{color: 'gray'}}/> {t('documentation.downloadzipfile')}
										</Button>
									}
									{ template &&
										<>
											{ template.exportDocumentConfigurations.sort((conf1, conf2) => conf1.name.localeCompare(conf2.name)).map(exportDocumentConfiguration => {
												return <ExportDocumentButton
													key={exportDocumentConfiguration.id}
													uuid={uuid}
													exportDocumentConfiguration={exportDocumentConfiguration}
													photos={photos}
												/>
											})}
										</>
									}
									{ hasFormProduct &&
										<>
											{ authService.hasExportDocumentTypes(['FORM_WORD_DOCUMENT']) &&
												<>
													<Button variant="outline-dark" onClick={e => downloadExportDocumentByType('FORM_WORD_DOCUMENT')} style={{display: 'none'}}>
														<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/> Word
													</Button>
													<ExportDocumentButton
														uuid={uuid}
														type={'FORM_WORD_DOCUMENT'}
														photos={photos}
													/>
												</>
											}
											{ authService.hasExportDocumentTypes(['FORM_3GIS_PM']) &&
												<>
													<Button variant="outline-dark" onClick={e => downloadExportDocumentByType('FORM_3GIS_PM')} style={{display: 'none'}}>
														<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/> Word
													</Button>
													<ExportDocumentButton
														uuid={uuid}
														type={'FORM_3GIS_PM'}
														photos={photos}
													/>
												</>
											}
											{ authService.hasExportDocumentTypes(['FORM_SHEAB_WORD_DOCUMENT']) &&
												<>
													<Button variant="outline-dark" onClick={e => downloadExportDocumentByType('FORM_SHEAB_WORD_DOCUMENT')} style={{display: 'none'}}>
														<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/> Sheab
													</Button>
													<ExportDocumentButton
														uuid={uuid}
														type={'FORM_SHEAB_WORD_DOCUMENT'}
														photos={photos}
													/>
												</>
											}
										</>
									}
									{ !hasFormProduct &&
										<>
											{ authService.hasExportDocumentTypes(['PHOTO_POWERPOINT_PRESENTATION']) &&
												<Button variant="outline-dark" onClick={e => downloadExportDocumentByType('PHOTO_POWERPOINT_PRESENTATION')}>
													<FontAwesomeIcon icon={faFilePowerpoint} style={{color: '#d04423'}}/> PowerPoint
												</Button>
											}
											{ authService.hasExportDocumentTypes(['PHOTO_WORD_DOCUMENT']) &&
												<Button variant="outline-dark" onClick={e => downloadExportDocumentByType('PHOTO_WORD_DOCUMENT')}>
													<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/> Word
												</Button>
											}
											{ authService.hasExportDocumentTypes(['PHOTO_EXCEL_WORKBOOK']) &&
												<Button variant="outline-dark" onClick={e => downloadExportDocumentByType('PHOTO_EXCEL_WORKBOOK')}>
													<FontAwesomeIcon icon={faFileExcel} style={{color: '#1f6e43'}}/> Excel
												</Button>
											}
											{ authService.hasExportDocumentTypes(['PHOTO_AXIANS_POWERPOINT_PRESENTATION']) &&
												<Button variant="outline-dark" onClick={e => downloadExportDocumentByType('PHOTO_AXIANS_POWERPOINT_PRESENTATION')}>
													<FontAwesomeIcon icon={faFilePowerpoint} style={{color: '#d04423'}}/> Axians PowerPoint
												</Button>
											}
										</>
									}
								</>
							}
			            </div>
		            </div>
		            { documentation.documentations && documentation.documentations.length > 0 &&
		                <Row>
			                <Col md="12">
			                    <b>{t('documentation.columns.documentations')}:</b>
			                    &nbsp;
			                    { documentation.documentations.map(other => {
			                        return <a key={other.id} href={other.id} target="_blank">
			                            {other.name}&nbsp;
			                        </a>
			                    })}
			                </Col>
			            </Row>
		            }
		            { documentation.alias &&
		                <Row>
			                <Col md="12">
			                    <b>{t('documentation.columns.originalname')}:</b> {documentation.name}
			                </Col>
			            </Row>
		            }
		            { template &&
		                <Row>
			                <Col md="12">
			                    <b>{t('documentation.columns.template')}:</b>
			                    &nbsp;
			                    { authService.hasRoles(['ROLE_TEMPLATE_READ']) &&
			                        <a href={'/template/details/' + template.id} target="_blank">{template.name}</a>
			                    }
			                    { !authService.hasRoles(['ROLE_TEMPLATE_READ']) &&
			                        template.name
			                    }
			                </Col>
			            </Row>
		            }
		            { documentation.tags.length > 0 &&
		                <Row>
			                <Col md="12">
			                    <b>{t('documentation.columns.tags')}:</b>
			                    &nbsp;
			                    { documentation.tags.join(',') }
			                </Col>
			            </Row>
		            }
		            <Row>
		                <Col md="12">
		                    <b>{t('documentation.columns.creator')}:</b> {documentation.creator}
		                </Col>
		            </Row>
		            <Row>
		                <Col md="12">
		                    <b>{t('documentation.columns.datecreated')}:</b> {moment(documentation.dateCreated).format(dateFormat)}
		                </Col>
		            </Row>
		            <Row>
		                <Col md="12">
		                    <b>{t('documentation.columns.dateuploaded')}:</b> {documentation.dateUploaded ? moment(documentation.dateUploaded).format(dateFormat) : '-'}
		                </Col>
		            </Row>
		            <Row>
		                <Col md="12">
		                    <b>{t('documentation.columns.appversion')}:</b> {documentation.appVersion || '-'}
		                </Col>
		            </Row>
		            <Row>
		                <Col md="12">
		                    <b>{t('documentation.columns.osversion')}:</b> {documentation.osVersion || '-'}
		                </Col>
		            </Row>
		            <Row>
		                <Col md="12">
		                    <b>{t('documentation.columns.phonemodel')}:</b> {documentation.phoneModel ? getProductName(documentation.phoneModel) : '-'}
		                </Col>
		            </Row>
		            <Row>
		                <Col md="12">
		                    <b>{t('documentation.columns.status')}: </b>
		                    <span>{formatStatus(documentation.status)}</span>
		                </Col>
		            </Row>
		            { documentationEvents.length > 0 &&
			            <Row>
			                <Col md="12">
			                    <b>{t('documentation.columns.events')}: </b>
			                    <table>
			                        <tbody>
					                    { documentationEvents.map(documentationEvent => {
					                        return <tr key={documentationEvent.id}>
					                            <td>
													{moment(documentationEvent.eventDate).format(dateFormat)}
												</td>
					                            <td style={{paddingLeft: '15px'}}>
					                                {getDocumentationEventType(documentationEvent)}
					                            </td>
					                            <td style={{paddingLeft: '15px'}}>
					                                {documentationEvent.creator}
					                            </td>
					                        </tr>
					                    })}
				                    </tbody>
			                    </table>
			                </Col>
			            </Row>
		            }
		            { documentation.lat != 1000 && documentation.lng != 1000 &&
		                <Row>
			                <Col md="12">
			                    <b>{t('documentation.columns.location')}: </b>
			                    <a href={'https://maps.google.com?q=' + documentation.lat + ',' + documentation.lng} target="_blank">
			                        {documentation.lat.toFixed(4)}, {documentation.lng.toFixed(4)}
			                    </a>
			                </Col>
			            </Row>
		            }
		            <Row>
		                <Col md="12">
			                <b>{t('documentation.columns.exportedto')}:</b>
			                { exportEvents.length == 0 &&
			                    <>-</>
			                }
			                { exportEvents.length > 0 &&
			                    <>
					                <table>
					                    <tbody>
							                { exportEvents.map(exportEvent => {
												return <tr key={exportEvent.id} style={{color: exportEvent.hidden ? 'lightgray' : 'auto'}}>
													<td>
														{moment(exportEvent.dateCreated).format(dateFormat)}
													</td>
													<td style={{paddingLeft: '15px'}}>
														{exportEvent.exportConfigurationName}
													</td>
													<td style={{paddingLeft: '15px'}}>
														{exportEvent.type}
													</td>
													{ exportEvents.some(ee => ee.username) &&
														<td style={{paddingLeft: '15px'}}>
															{exportEvent.username || '-'}
														</td>
													}
													<td style={{paddingLeft: '15px'}}>
														{ !exportEvent.success &&
															<>
																<FontAwesomeIcon icon={faExclamationTriangle} style={{color: '#FF0000'}}/>
																{ exportEvent.errorStatusCode &&
																	<b style={{paddingLeft: '5px'}}>
																		{exportEvent.errorStatusCode}
																	</b>
																}
																{ exportEvent.errorMessage &&
																	<span style={{paddingLeft: '5px'}}>
																		{exportEvent.errorMessage}
																	</span>
																}
															</>
														}
													</td>
													{ authService.hasRoles(['ROLE_SUPER_ADMIN']) && !exportEvent.hidden &&
														<td style={{paddingLeft: '15px'}}>
															<a href="#" onClick={e => hideExportEvent(e, exportEvent)}>
																<FontAwesomeIcon icon={faEyeSlash}/>
															</a>
														</td>
													}
												</tr>
							                })}
						                </tbody>
					                </table>
					                { photos.some(photo => photo.exportEvents.length > 0) &&
					                    <Button variant="outline-dark" onClick={() => setShowExportPhotoEventModal(true)}>
											{t('documentation.showphotoexports')}
										</Button>
					                }
					                { files.some(file => file.exportEvents.length > 0) &&
					                    <Button variant="outline-dark" onClick={() => setShowExportFileEventModal(true)}>
											{t('documentation.showfileexports')}
										</Button>
					                }
				                </>
			                }
		                </Col>
		            </Row>
		            { documentationTasks.some(task => task.unexpectedAnswerEvents.length != 0) &&
		                <Row>
			                <Col md="6" sm="12">
			                    <b>{t('documentation.unexpectedanswerevents')}:</b>
			                    <div className="alert alert-danger" role="alert">
			                        { documentationTasks.filter(task => task.unexpectedAnswerEvents.length != 0).map(task => {
			                            return <div key={task.id}>
			                                { task.unexpectedAnswerEvents.map(event => {
					                            return <span key={event.id}>
					                                <b>{task.name}</b> {t('documentation.expectedanswer', {list: event.expectedAnswerListName, answer: event.expectedAnswer})}
					                            </span>
					                        })}
			                            </div>
			                        })}
								</div>
			                </Col>
			            </Row>

		            }
		            { documentation.dateDeleted &&
			            <Row>
			                <Col md="12">
			                    <b>{t('documentation.columns.datedeleted')}: </b>
			                    {moment(documentation.dateDeleted).format(dateFormat)}
			                </Col>
			            </Row>
		            }
                    { !documentation.dateDeleted &&
                        <>
                            <hr/>
	                        { (hasFormProduct && documentation.numberOfTasks != 0) &&
	                            <>
	                                { documentationTasks.some(task => task.type == 'GROUP') &&
	                                    <>
			                                <Button variant="outline-dark" onClick={openAllGroups}>
												{t('documentation.openallgroups')}
											</Button>
											<Button variant="outline-dark" onClick={closeAllGroups}>
												{t('documentation.closeallgroups')}
											</Button>
										</>
									}
									<DocumentationTaskFilter filters={filters} setFilters={setFilters} showUnanswered={showUnanswered} setShowUnanswered={setShowUnanswered}/>
									{ documentationTasks.filter(task => task.parent == null).map(task => {
										task.enabled = checkPreconditions(task)
										let show = showTask(task) && checkFilters(task)
										if (task.enabled && show) {
											return <Row key={task.id} style={{paddingTop: '20px'}}>
												<Col md="12" style={{paddingTop: '10px', border: '1px solid #ccc'}}>
													<h5 style={{color: task.enabled ? 'auto' : '#BBBBBB'}}>
														<div style={{minWidth: '1em', display: 'inline-block', textAlign: 'center'}}>
															{getDocumentationTaskIcon(task)}
														</div>
														&nbsp;
														{task.name}
														{ authService.hasRoles(['ROLE_EDIT_DOCUMENTATION']) && isEditable(task) &&
															<>
																&nbsp;
																<EditTaskButton
																	data={task}
																	documentation={documentation}
																	onUpdate={onUpdateTask}
																/>
															</>
														}
														&nbsp;
														<TaskEventButton task={task}/>
														{ task.type == "GROUP" &&
															<a onClick={(e) => toggleGroup(task)} style={{cursor: 'pointer', paddingLeft: '10px'}}>
																<FontAwesomeIcon icon={task.expanded ? faChevronUp : faChevronDown}/>
															</a>
														}
													</h5>
													{ task.description &&
														<i style={{color: task.enabled ? 'auto' : '#BBBBBB'}}>{task.description}</i>
													}
													{getDocumentationTaskView(task)}
												</Col>
											</Row>
										}
										return ''
									})}
								</>
	                        }
	                        { (!hasFormProduct || documentation.numberOfTasks == 0) &&
		                        <>
									<Row style={{paddingTop: '20px'}}>
						                <Col md="6">
						                    <h4>{t('photo.label')}</h4>
						                </Col>
						                <Col md="6">
						                    <div className="float-right">
								                <b>{t('documentation.sort.sortby')}: </b>
								                <select className="form-control" onChange={(event) => setSort(event.target.value)} style={{width: '200px', display: 'inline'}}>
								                    <option value="name">{t('documentation.columns.name')}</option>
								                    <option value="dateCreated">{t('documentation.columns.datecreated')}</option>
								                </select>
								                <select className="form-control" onChange={(event) => setOrder(event.target.value)} style={{width: '200px', display: 'inline'}}>
								                    <option value="asc">{t('documentation.sort.ascending')}</option>
								                    <option value="desc">{t('documentation.sort.descending')}</option>
								                </select>
								            </div>
						                </Col>
						            </Row>
						            <Row>
						                {sortPhotos().map(photo => {
						                    return <Col lg="2" md="3" sm="4" xs="6" key={photo.id}>
						                        <div className="clearfix" style={{paddingTop: '20px'}}>
													<div className="float-left">
						                                {photo.alias || photo.name}
						                            </div>
						                            { authService.hasRoles(['ROLE_PHOTO_WRITE']) &&
							                            <div className="float-right" style={{"marginBottom": "1px"}}>
							                                <EditPhotoButton
																data={photo}
																onUpdate={onUpdatePhoto}
															/>
															<DeletePhotoButton
																data={photo}
																onDelete={onDeletePhoto}
															/>
							                            </div>
						                            }
						                        </div>
												<a onClick={() => onClick(photo)} key={photo.id} style={{cursor: 'pointer'}}>
							                        <img src={SERVER_URL + '/photo/thumbnail/' + photo.id + '?t=' + photo.lastUpdated} style={{width: '100%'}}/>
							                    </a>
							                    <br/>
							                    {photo.comment ? '(' + photo.comment + ')' : ''}
						                    </Col>
						                })}
						            </Row>
						        </>
					        }
				        </>
                    }
		            <Row>&nbsp;</Row>
					<Modal
						style={{overflow: 'scroll'}}
						size="xl"
						show={showPhotoModal}
						backdrop={backdrop}
						onShow={() => console.log('onShow')}
						onHide={onHide}
						animation={false}>
						<Modal.Header closeButton>
							<Pagination style={{marginBottom: 0}}>
								<Pagination.Item
									disabled={photoIndex == 0}
									onClick={e => setPhotoIndex(0)}
								>
						            <FontAwesomeIcon icon={faAnglesLeft} style={{fontSize: 12}}/>
						        </Pagination.Item>
								<Pagination.Item
									disabled={photoIndex == 0}
									onClick={e => setPhotoIndex(photoIndex-1)}
								>
						            <FontAwesomeIcon icon={faAngleLeft} style={{fontSize: 12}}/>
						        </Pagination.Item>
								{getPaginationItems()}
								<Pagination.Item
									disabled={photoIndex == photos.length-1}
									onClick={e => setPhotoIndex(photoIndex+1)}
								>
						            <FontAwesomeIcon icon={faAngleRight} style={{fontSize: 12}}/>
						        </Pagination.Item>
								<Pagination.Item
									disabled={photoIndex == photos.length-1}
									onClick={e => setPhotoIndex(photos.length-1)}
								>
						            <FontAwesomeIcon icon={faAnglesRight} style={{fontSize: 12}}/>
						        </Pagination.Item>
							</Pagination>
						</Modal.Header>
						<Modal.Body>
							{ sortPhotos().map((photo, index) =>
								<Row key={photo.id + '-' + index}>
									{ index == photoIndex &&
										<>
											<Col sm="12" style={{textAlign: 'left'}}>
												<h2>{photo.alias || photo.name}</h2>
											</Col>
											<Col>
												<ImageZoom src={SERVER_URL + '/photo/download/' + photo.id + '?t=' + photo.lastUpdated} zoom="400"/>
											</Col>
											<Col sm="3" style={{textAlign: 'left'}}>
												<ul style={{listStyleType: 'none', paddingLeft: 0}}>
													<li>
														<b>{t('photo.columns.link')}</b>
													</li>
													<li style={{wordBreak: 'break-all'}}>
														<a href={SERVER_URL + '/photo/download/' + photo.id} target="_blank">
															{SERVER_URL + '/photo/download/' + photo.id}
														</a>
													</li>
													<li>
														<b>{t('photo.columns.comment')}</b>
													</li>
													<li>
														{photo.comment || '-'}
													</li>
													<li>
														<b>{t('photo.columns.datecreated')}</b>
													</li>
													<li>
														{moment(photo.dateCreated).format(dateFormat)}
													</li>
													<li>
														<b>{t('photo.columns.dateuploaded')}</b>
													</li>
													<li>
														{moment(photo.dateUploaded).format(dateFormat)}
													</li>
													<li>
														<b>{t('photo.columns.imported')}</b>
													</li>
													<li>
														{photo.imported ? t('crudtable.yes') : t('crudtable.no')}
													</li>
													{ photo.lat != 1000 && photo.lng != 1000 &&
														<>
															<li>
																<b>{t('photo.columns.position')}</b>
															</li>
															<li>
																<a href={'https://www.google.com/maps/search/?api=1&query=' + photo.lat + '%2C' + photo.lng} target="_blank">
																	{photo.lat}, {photo.lng}
																</a>
															</li>
														</>
													}
													{ photo.hasOriginalData &&
														<>
															<li>
																<b>{t('photo.columns.original')}</b>
															</li>
															<li>
																<a href={SERVER_URL + '/photo/downloadOriginal/' + photo.id} target="_blank">
																	{SERVER_URL + '/photo/downloadOriginal/' + photo.id}
																</a>
															</li>
														</>
													}
												</ul>
											</Col>
										</>
									}
								</Row>
							)}
						</Modal.Body>
					</Modal>
					<Modal
						style={{overflow: 'scroll'}}
						size="lg"
						show={showExportPhotoEventModal}
						backdrop={backdrop}
						onShow={() => console.log('onShow')}
						onHide={onHideExportPhotoEventModal}
						animation={false}>
						<Modal.Header closeButton>
							<Modal.Title>{t('documentation.photoexports')}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
			                { sortPhotos().map(photo => {
								return <Row key={'exportPhotoEventModal-' + photo.id} style={{marginBottom: '10px'}}>
							        <Col lg="12">
							            <div>
							                {photo.alias || photo.name}
							            </div>
							            <div>
							                { photo.comment &&
							                    <span>({photo.comment})</span>
							                }
							            </div>
				                    </Col>
				                    <Col lg="3">
						                <img src={SERVER_URL + '/photo/thumbnail/' + photo.id + '?t=' + photo.lastUpdated} style={{width: '100%'}}/>
				                    </Col>
				                    <Col lg="9">
										<table style={{width: '100%'}}>
						                    <tbody>
								                { photo.exportEvents.sort((a, b) => a.dateCreated.localeCompare(b.dateCreated)).map(exportEvent => {
													return <tr key={exportEvent.id}>
														<td>
															{moment(exportEvent.dateCreated).format(dateFormat)}
														</td>
														<td style={{paddingLeft: '15px'}}>
															{exportEvent.exportConfigurationName}
														</td>
														<td style={{paddingLeft: '15px'}}>
															{exportEvent.type}
														</td>
														{ photo.exportEvents.some(ee => ee.username) &&
															<td style={{paddingLeft: '15px'}}>
																{exportEvent.username || '-'}
															</td>
														}
														<td style={{paddingLeft: '15px'}}>
															{ !exportEvent.success &&
																<FontAwesomeIcon icon={faExclamationTriangle} style={{color: '#FF0000'}}/>
															}
														</td>
													</tr>
								                })}
							                </tbody>
						                </table>
				                    </Col>
					            </Row>
				            })}
						</Modal.Body>
						<Modal.Footer>
							<Button variant="outline-dark" onClick={onHideExportPhotoEventModal}>
								{t('crudtable.ok')}
							</Button>
						</Modal.Footer>
					</Modal>
					<Modal
						style={{overflow: 'scroll'}}
						size="lg"
						show={showExportFileEventModal}
						backdrop={backdrop}
						onShow={() => console.log('onShow')}
						onHide={onHideExportFileEventModal}
						animation={false}>
						<Modal.Header closeButton>
							<Modal.Title>{t('documentation.fileexports')}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
			                { files.map(file => {
								return <Row key={'exportFileEventModal-' + file.id} style={{marginBottom: '10px'}}>
							        <Col lg="12">
							            <div>
							                {file.name}
							            </div>
				                    </Col>
				                    <Col lg="12">
										<table style={{width: '100%'}}>
						                    <tbody>
								                { file.exportEvents.sort((a, b) => a.dateCreated.localeCompare(b.dateCreated)).map(exportEvent => {
													return <tr key={exportEvent.id}>
														<td>
															{moment(exportEvent.dateCreated).format(dateFormat)}
														</td>
														<td style={{paddingLeft: '15px'}}>
															{exportEvent.exportConfigurationName}
														</td>
														<td style={{paddingLeft: '15px'}}>
															{exportEvent.type}
														</td>
														{ file.exportEvents.some(ee => ee.username) &&
															<td style={{paddingLeft: '15px'}}>
																{exportEvent.username || '-'}
															</td>
														}
														<td style={{paddingLeft: '15px'}}>
															{ !exportEvent.success &&
																<FontAwesomeIcon icon={faExclamationTriangle} style={{color: '#FF0000'}}/>
															}
														</td>
													</tr>
								                })}
							                </tbody>
						                </table>
				                    </Col>
					            </Row>
				            })}
						</Modal.Body>
						<Modal.Footer>
							<Button variant="outline-dark" onClick={onHideExportFileEventModal}>
								{t('crudtable.ok')}
							</Button>
						</Modal.Footer>
					</Modal>
				</>
			}
        </div>
    )
}

export default DocumentationDetails;